<template>
  <div v-show="textureList.length" class="comp-main">
    <div class="group-list">
      <div class="group-item">
        <div class="group-top">材质</div>
        <div class="group-center">
          <el-input
            size="mini"
            prefix-icon="el-icon-search"
            :placeholder="`筛选材质`"
            clearable
            v-model="keyword"
            @input="filterTexture($event)"
          />
          <div class="group-cont">
            <c-list-empty v-if="!textureList.length" />
            <div
              v-for="(item, index) in textureList"
              :key="index"
              :class="{ 'texture-item': true, active: selfData.id === item.id }"
              @click="textureChoose(item)"
              v-show="item.isShow"
            >
              <span class="texture-name">{{ item.key }}</span>
              <div>
                <span v-if="item.has_children" class="iconfont icon-arrow-right c-gray-light" />
                <span v-else class="iconfont icon-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categoryId: {
      type: [String, Number],
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFirst: true,
      keyword: '',
      textureList: [],
      selfData: {}
    }
  },
  watch: {
    categoryId(id) {
      this.keyword = ''
      if (id) {
        this.getTextureListList(id)
      } else {
        this.textureChoose({})
        this.textureList = []
      }
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取材质列表数据
    getTextureListList(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/midu/list',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.textureList = res.data.list.map((item) => {
            let obj = {
              id: item.id,
              key: item.cai_zhi,
              val: item.val,
              isShow: true
            }
            return obj
          })
          if (this.isFirst && this.textureList.length) {
            if (this.data && this.data.key) return
            this.selfData = this.$util.deepCopy(this.textureList[0])
            this.textureChoose(this.selfData, true)
          } else {
            this.textureChoose({})
          }
          this.isFirst = false
        }
      })
    },
    // 材质筛选
    filterTexture(keyword) {
      this.textureList.forEach((item) => {
        item.isShow = item.key.includes(keyword)
      })
    },
    // 材质选择
    textureChoose(val, isFirst = false) {
      this.$emit('update:data', this.$util.deepCopy(val))
      // 是否隐藏类目 = 不是第一次加载 && 选中末级分类 && (材质列表为空 || (材质列表不为空 && 选中材质))
      let isHideCategory =
        !isFirst &&
        this.categoryId &&
        (!this.textureList.length || (this.textureList.length && JSON.stringify(val) !== '{}'))
      if (isHideCategory) {
        this.$emit('hide')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  min-height: 28px;
  .group-list {
    display: flex;
    .group-item {
      display: flex;
      flex-direction: column;
      width: 200px;
      line-height: 26px;
      background: @colorWhite;
      border: 1px solid #e4e7ed;
      & ~ .group-item {
        border-left: none;
      }
      &:first-child {
        border-radius: 2px 0 0 2px;
      }
      &:last-child {
        border-radius: 0 2px 2px 0;
      }
      .group-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 5px;
        background: #f8f8f9;
      }
      .group-center {
        height: 252px;
        border-top: 1px solid #e4e7ed;
        .group-cont {
          height: 224px;
          overflow-y: auto;
          .scroll-bar();
        }
        /deep/ .el-input {
          height: 28px;
          .el-input__inner {
            height: 28px;
            line-height: 26px;
            border: none;
            border-radius: 0;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #e4e7ed;
          }
        }
        .texture-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 28px;
          padding: 0 5px;
          cursor: pointer;
          .icon-right,
          .icon-edit,
          .icon-delete {
            display: none;
          }
          &:hover,
          &.active {
            background: @colorBlue10;
          }
          &.active {
            .texture-name,
            .icon-arrow-right,
            .icon-right {
              color: @colorBlue;
            }
            .icon-right,
            .icon-edit,
            .icon-delete {
              display: block;
            }
            .icon-edit:hover,
            .icon-delete:hover {
              color: @colorBlue;
            }
          }
        }
      }
    }
  }
  .iconfont {
    cursor: pointer;
    & ~ .iconfont {
      margin-left: 5px;
    }
  }
}
</style>
